import {useContext} from 'react'
import axios from 'axios'
import { QlikUIContext } from '../../QlikUIContext'

export function useQlikTicketApi() {

    const context = useContext(QlikUIContext);

    const AxiosInstance = axios.create({
        timeout: 30000
        });
    
    AxiosInstance.defaults.validateStatus = (status) => {
        return (status >= 200 && status < 300) || status === 498;
    };
        
    AxiosInstance.interceptors.request.use(
        config => {
            config.headers['Ocp-Apim-Subscription-Key'] = context.subscription 
            config.headers['Authorization'] = `Bearer ` + context.securityToken 
            return config;
        },
        error => {
            return Promise.reject(error);
        }
    );
    
    AxiosInstance.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if (error.code === 'ECONNABORTED') {
                // TODO: i18n
                console.log('Se ha perdido la conexion con el servidor (timeout)');
            } else if (error.response?.status === 412) {
            // Rulebook errors
                console.log('ERROR 412', error.response);
    
                return Promise.reject({
                    statusCode: error.response.status,
                    errors: error.response.data.value.map(x => x.errorCode)
                });
            } else {
                console.log('ERROR interceptor', error.response, {
                    statusCode: error.response?.status,
                    errors: [error.response ? error.response.statusText : '']
                });
    
                return Promise.reject({
                    statusCode: error.response?.status,
                    errors: null
                });
            }
            return Promise.reject(error);
        }
    );

    async function GetQlikTicket(name, server) {
        return await AxiosInstance.get(
            `${context.reportsQlikApiEndpoint}/ticket`
          )
            .then(response => {
              return response.data.ticket;
            })
            .catch(() => {
              return null;
            });
    }

    return { GetQlikTicket };
}